<template id="salesmanDashboard">
  <section class="ms-root">
    <div class="ms-page" :class="{ 'ms-page--plain': !showAnalyticsNav }">
      <header v-if="!shouldShowHeader" class="ms-header ms-animate-header">
        <button
            v-if="this.$route.path!=='/mobile-screen'"
            type="button"
            class="ms-header__back ms-animate-back"
            aria-label="Go back"
            @click="backButton"
        >
          <i class="fas fa-arrow-left"></i>
        </button>
        <div v-if="!shouldShowHeader" class="ms-header__logo-panel ms-animate-logo">
          <img
              v-if="this.$route.path==='/field/deepdive' || this.$route.path==='/field/simple' || this.$route.path==='/field/landing'"
              class="ms-header__logo"
              src="@/assets/COMPEGENCE_logo-compressed.jpeg"
              alt="Compegence"
          />
          <img
              v-else
              class="ms-header__logo"
              :src="logoPath"
              alt="Client logo"
          />
          <p class="ms-header__powered ms-animate-powered">
            Powered by
            <a href="https://compegence.com/products" target="_blank" rel="noopener">
              <span class="ms-fw ms-fw--fore">Fore</span><span class="ms-fw ms-fw--warn">Warn</span>
            </a>
          </p>
        </div>
      </header>

      <!-- <div
          v-if="this.$route.path!=='/mobile-screen' && showAnalyticsNav"
          class="ms-status-pill"
      >
        <span class="ms-status-pill__dot"></span>
        Mobile-ready · Embeddable
      </div> -->

      <nav
          v-if="showAnalyticsNav"
          class="ms-analytics ms-animate-nav"
          :class="{ 'ms-analytics--expanded': !menuPath }"
      >
        <h2 class="ms-analytics__heading ms-animate-heading">Analytics Views</h2>
        <div class="ms-analytics__list">
          <button
              v-for="(item, index) in fieldNavItems"
              :key="item.id"
              type="button"
              class="ms-card ms-animate-card"
              :class="{
                'ms-card--active': menuPath === item.id,
                'ms-card--accent': item.accent,
                'ms-card--disabled': item.disabled,
                'ms-card--pressed': pressedCardId === item.id
              }"
              :style="{ '--card-index': index }"
              :disabled="item.disabled"
              @click="onCardClick(item, $event)"
          >
            <span class="ms-card__icon" :class="{ 'ms-card__icon--danger': item.iconDanger }">
              <i :class="item.icon"></i>
            </span>
            <span class="ms-card__body">
              <span class="ms-card__title">{{ item.label }}</span>
              <span class="ms-card__subtitle">{{ item.subtitle }}</span>
            </span>
            <i v-if="!item.disabled" class="fas fa-chevron-right ms-card__chevron"></i>
          </button>
        </div>
      </nav>

      <nav
          v-if="$route.path === '/mobile-screen'"
          class="ms-analytics ms-reports ms-animate-nav"
          :class="{ 'ms-analytics--expanded': !menuPath }"
          aria-label="Mobile reports"
      >
        <div v-if="reportNavItems.length" class="ms-analytics__list">
          <button
              v-for="(item, index) in reportNavItems"
              :key="item.id"
              type="button"
              class="ms-card ms-animate-card"
              :class="{
                'ms-card--accent': index === 0,
                'ms-card--pressed': pressedCardId === item.id
              }"
              :style="{ '--card-index': index }"
              @click="onReportClick(item, $event)"
          >
            <span class="ms-card__icon">
              <i :class="item.icon" aria-hidden="true"></i>
            </span>
            <span class="ms-card__body">
              <span class="ms-card__title">{{ item.label }}</span>
            </span>
            <i class="fas fa-chevron-right ms-card__chevron" aria-hidden="true"></i>
          </button>
        </div>

        <div v-else class="ms-reports__empty">
          <span class="ms-reports__empty-icon"><i class="fas fa-folder-open"></i></span>
          <p class="ms-reports__empty-title">No reports available</p>
          <p class="ms-reports__empty-text">Ask your admin to configure mobile reports.</p>
        </div>
      </nav>

      <transition name="ms-dashboard" mode="out-in">
        <div
            v-if="this.$route.path!=='/mobile-screen' && (menuPath==='deepdive' || this.$route.path==='/field/deepdive' || menuPath==='simple' || this.$route.path==='/field/simple')"
            key="dashboard"
            class="card-deck m-3 ms-dashboard-panel"
        >
          <div v-if="menuPath==='deepdive' || this.$route.path==='/field/deepdive'" class="card-body p-1">
            <sales-dashboard ref="salesDashboard" :id="id" :viz1="vizData[0]" :filters="filter" :sales-data="salesData"/>
          </div>

          <div v-if="menuPath==='simple' || this.$route.path==='/field/simple'" class="card-body p-1">
            <sales-dashboard-v1 ref="salesDashboardv1" :id="id" :viz1="vizData[0]" :filters="filter"
                                :sales-data="salesData"/>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>
<script>

import SalesDashboardV1 from "@/components/SalesDashboardV1.vue";
import SalesDashboard from "@/components/SalesDashboard.vue";
import axios from 'axios';
import {isDescendant} from "@/common/functions";

export default {
  name: "salesmanDashboard",
  components: {SalesDashboard, SalesDashboardV1},
  props: {
    screenlet: Number,
    sl: Object,
    scrnPropTime: Date,
    screenletId: String
  },
  watch: {
    $props: {
      handler() {
        this.loadSummary()
      },
      deep: true,
      immediate: true,
    },
    '$route.path': {
      handler(newPath) {
        if (newPath === '/field/deepdive') {
          console.log("inside watch")
          this.goToDeepDive();
        }
        if (newPath === '/field/simple') {
          console.log("inside watch")
          this.goToSimple();
        }
      },
      immediate: true
    }
  },
  data: () => ({
    optionValues: ['a', 'b'],
    loadViz: false,
    menuPath: '',
    salesData: [],
    filter: {},
    searching: false,
    vizData: [],
    screenName: '',
    time3: '',
    propTime: null,
    f: {
      userName: 'field_demo',
      password: 'FieldDemo@123',
    },
    id: `VIZ-${new Date().getTime()}`,
    // logoPath: null,
    subMenuParam: null,
    logoPath: null,
    pressedCardId: null
  }),
  computed: {
    shouldShowHeader() {
      return this.shouldShowNavPart('nav-header')
    },
    showAnalyticsNav() {
      return this.subMenuParam === null
          && this.$route.path !== '/field/deepdive'
          && this.$route.path !== '/field/simple'
          && this.$route.path !== '/mobile-screen';
    },
    reports() {
      const menuFlat = this.$store.state.menuMasterFlat || []
      const mobileMenu = menuFlat.find(item => item.menuId === 'Mobile')
      const list = mobileMenu?.menuRenderJson?.reports
      return Array.isArray(list) ? list : []
    },
    reportNavItems() {
      return this.reports.map((report, index) => {
        const label = report.label || report.name || `Report ${index + 1}`
        const url = report.url || ''
        const pathHint = url
          ? String(url).replace(/^\/+/, '').split('/').filter(Boolean).slice(-2).join(' · ')
          : 'Mobile report'
        return {
          id: `report-${index}-${url || label}`,
          label,
          subtitle: report.subtitle || report.description || pathHint || 'Open report view',
          icon: report.icon || 'fas fa-chart-line',
          url
        }
      })
    },
    fieldNavItems() {
      return [
        {
          id: 'deepdive',
          label: 'Deep Dive',
          subtitle: 'Detailed drill-down analysis',
          icon: 'fas fa-search',
          accent: true,
          iconDanger: false,
          disabled: false,
          action: () => this.goToDeepDive()
        },
        {
          id: 'simple',
          label: 'MTD · QTD · YTD',
          subtitle: 'Period-over-period summaries',
          icon: 'fas fa-calendar-alt',
          accent: false,
          iconDanger: false,
          disabled: false,
          action: () => this.goToSimple()
        },
        {
          id: 'allViz',
          label: 'All Visualizations',
          subtitle: 'Complete dashboard library',
          icon: 'fas fa-chart-bar',
          accent: false,
          iconDanger: false,
          disabled: false,
          action: () => this.goToAllViz()
        },
        {
          id: 'viewField',
          label: 'View Field',
          subtitle: 'Field service & operations',
          icon: 'fas fa-map-marker-alt',
          accent: false,
          iconDanger: true,
          disabled: true,
          action: () => {}
        },
        {
          id: 'deepHost',
          label: 'Deep Host',
          subtitle: 'Host-level drilldown',
          icon: 'fas fa-server',
          accent: false,
          iconDanger: false,
          disabled: true,
          action: () => {}
        }
      ];
    }
  },
  async created() {
    console.log("this router", this.$route);

    let restrictedMenu = this.$store.state.user.userRoleRestriction.menuAccessInclusionArray || []
    let exclusionArray = this.$store.state.user.userRoleRestriction.menuAccessExclusionArray || [];
    const menuTree = this.$store.state.menuMasterData.filter(m => m.parentMenuId === 'Root') || []

    // Handle empty/undefined/null/["[]"] cases - all menus allowed
    const isAllMenusAllowed = !restrictedMenu ||
        restrictedMenu.length === 0 ||
        (restrictedMenu.length === 1 && restrictedMenu[0] === "[]")

    if (!isAllMenusAllowed) {
      const currentMenuId = this.$route.params.menuId
      const currentSubmenuId = this.$route.params.submenuId

      // Only check menu restrictions for routes that have these parameters
      if (currentMenuId || currentSubmenuId) {
        // Check if current IDs are in exclusion array
        const isExcluded = exclusionArray.includes(currentMenuId) ||
            exclusionArray.includes(currentSubmenuId)
        // If NEITHER menuId NOR submenuId is in the allowed list, block access
        // Check whether current IDs are directly allowed or descendants of allowed ones
        const isAllowed =
            restrictedMenu.includes(currentMenuId) ||
            restrictedMenu.includes(currentSubmenuId) ||
            isDescendant(menuTree, restrictedMenu, currentMenuId) ||
            isDescendant(menuTree, restrictedMenu, currentSubmenuId);

        if (!isAllowed || isExcluded) {
          // window.alert("Invalid action, request please contact your Administrator")
          // You might want to redirect to user-restrict page here as well
          await this.$router.push('/user-restrict')
          return; // Stop execution
        }
      }
    }
    this.listenToRouter();
    this.getLogoPath();
  },
  mounted() {
    this.handleFirstVisitReload();
  },
  methods: {
     /**
     * Mobile nav visibility from deviceLandingPageConfig (user overrides role).
     * - Desktop: always show
     * - Mobile: show when value === "show"; hide when value === "hide" (or missing)
     */
     shouldShowNavPart(configKey) {
      const state = this.$store.state

      if (!state.isLoggedIn || !state.stateLoaded || !state.isAppMenuAndAppHeaderDisplay) {
        return false
      }

      if (state.deviceType === 'Desktop') {
        return true
      }

      if (state.deviceType === 'Mobile') {
        const userVal = state.user?.deviceLandingPageConfig?.[configKey]
        const roleVal = state.userRoleRestriction?.deviceLandingPageConfig?.[configKey]
        const value = userVal != null ? userVal : roleVal
        return value === 'show'
      }

      return false
    },
    handleFirstVisitReload() {
      console.log("reload function called")
      const hasReloaded = localStorage.getItem('hasReloaded');

      if (!hasReloaded) {
        localStorage.setItem('hasReloaded', 'true');

        // Force a hard reload (avoids caching issues)
        window.location.reload(); // `true` forces a cache bypass (deprecated in some browsers)

        // Alternative (modern approach):
        // window.location.href = window.location.href;
      }
    },
    async goToMobileScreen(url) {
      if (!url) return
      await this.$router.push(url);
    },
    playCardPress(el, event, id) {
      const rect = el.getBoundingClientRect();
      const x = ((event.clientX || rect.left + rect.width / 2) - rect.left) / rect.width * 100;
      const y = ((event.clientY || rect.top + rect.height / 2) - rect.top) / rect.height * 100;
      el.style.setProperty('--ripple-x', `${x}%`);
      el.style.setProperty('--ripple-y', `${y}%`);
      this.pressedCardId = id;
      setTimeout(() => {
        this.pressedCardId = null;
      }, 280);
    },
    onReportClick(item, event) {
      if (!item?.url) return
      this.playCardPress(event.currentTarget, event, item.id)
      this.goToMobileScreen(item.url)
    },
    onCardClick(item, event) {
      if (item.disabled) return;
      this.playCardPress(event.currentTarget, event, item.id);
      item.action();
    },
    backButton() {
      console.log("back button called")
      this.$router.push('/field/landing')
      this.menuPath ='';
      this.subMenuParam = null;
      // window.location.reload();
    },
    goToDeepDive() {
      console.log("deepdive called ")
      this.menuPath = 'deepdive';
      this.subMenuParam = 'RDemo1'
      this.loadSummary();
      this.$router.push('/field/deepdive')
    },
    goToSimple() {
      this.menuPath = 'simple';
      this.subMenuParam = 'RDemo2'
      this.loadSummary();
      this.$router.push('/field/simple')
    },
    goToAllViz() {
      this.menuPath = 'allViz';
      this.subMenuParam = 'RDemo2'
      this.loadSummary();
      this.$router.push('/mobile-dashboard/Z2Rupee/MDR001')
    },

    getLogoPath: function () {
      console.log('logo-path', 'load state');
      this.$store.dispatch("loadState").then((cfg) => {
        console.log("logooo", cfg.fwMClient)
        this.fwMClient = cfg.fwMClient
        this.logoPath = "/img" + this.fwMClient[0].clientLogoPath['mobile']
        console.log("client", this.fwMClient)
      })
    },
    loadSummary: function () {
      if (this.subMenuParam) {
        axios.post(`/auth/login`, this.f).then(response => {
          console.log(response);
          if (response.status === 200) {
            this.$store.commit('loggedIn', response.data['authToken']);
            // this.$store.dispatch('checkUserLogin');
            // this.$store.dispatch("loadState");
            this.$store.commit('isAppMenuAndAppHeaderDisplay', false)

            axios.get('/api/state')
                .then(res => {

                  if (res.status === 200) {
                    this.$store.commit('setState', res.data)
                    // this.getLogoPath()

                    this.propTime = new Date();
                    this.loadViz = true


                    let allVizData = this.$store.state.fwConfigScreenElement

                    if (this.screenletId) {
                      this.vizData = allVizData.filter(r => r.menuId === this.subMenuParam && r.screenletInstanceId === this.screenletId)
                    } else {
                      this.vizData = allVizData.filter(r => r.menuId === this.subMenuParam)
                    }

                    console.log("this.vizData", this.vizData);

                    if(this.menuPath!=='allViz') {
                      var url = '/api/fetchDataWithParam/' + this.vizData[0].datasqlId + '/' + 'CommonVizClass'
                      axios.post(url, this.filter).then(resp => {
                        this.salesData = resp.data
                      })
                    }
                  }
                })
          }
        }).catch(error => {
          this.errorTitle = error.response && error.response.data ? error.response.data.error : 'Something went wrong';
          this.$store.commit('authError');
          this.loginFailed = !this.$store.state.serverIsDown;
          this.show = false;
        });
      }
    },
    listenToRouter: function () {
      console.log("listenToRouter is called")
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        $this.rows = []
        $this.menuPath = ''
        $this.subMenuParam = null
        $this.time3 = ''
        setTimeout(() => {
          if($this.$route.path!=='/mobile-screen') {
            $this.loadSummary()
          }
          // $this.loadSummary($this.x)
        }, 300)

      })
    },
  }
}
</script>
<style scoped>
/* ── Keyframes ── */
@keyframes ms-header-in {
  from { opacity: 0; transform: translateY(-18px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes ms-logo-in {
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes ms-fade-up {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes ms-card-in {
  from {
    opacity: 0;
    transform: translateY(22px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes ms-float-orb {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(12px, -8px) scale(1.04); }
  66% { transform: translate(-8px, 10px) scale(0.98); }
}

@keyframes ms-accent-pulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(227, 23, 23, 0.35); }
  50% { opacity: 0.85; box-shadow: 0 0 8px 2px rgba(227, 23, 23, 0.2); }
}

@keyframes ms-icon-pop {
  0% { transform: scale(1); }
  40% { transform: scale(1.18) rotate(-4deg); }
  100% { transform: scale(1.08) rotate(0deg); }
}

@keyframes ms-chevron-nudge {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(5px); }
}

@keyframes ms-active-glow {
  0%, 100% { box-shadow: 0 6px 20px rgba(59, 130, 219, 0.35); }
  50% { box-shadow: 0 8px 28px rgba(59, 130, 219, 0.48); }
}

@keyframes ms-ripple {
  from {
    opacity: 0.45;
    transform: scale(0);
  }
  to {
    opacity: 0;
    transform: scale(2.4);
  }
}

@keyframes ms-powered-shimmer {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.75; }
}

/* Page shell — matches mockup dot-pattern background */
.ms-root {
  min-height: 100%;
}

.ms-page {
  position: relative;
  min-height: 100vh;
  padding: 0 16px 24px;
  background-color: #e9f2fc;
  background-image:
      radial-gradient(circle at 20% 15%, rgba(255, 255, 255, 0.55) 0, transparent 42%),
      radial-gradient(circle at 80% 35%, rgba(255, 255, 255, 0.4) 0, transparent 38%),
      radial-gradient(circle at 50% 70%, rgba(200, 220, 245, 0.35) 0, transparent 45%);
  overflow-x: hidden;
}

.ms-page::before,
.ms-page::after {
  content: '';
  position: fixed;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
  animation: ms-float-orb 14s ease-in-out infinite;
}

.ms-page::before {
  width: 220px;
  height: 220px;
  top: 28%;
  right: -60px;
  background: radial-gradient(circle, rgba(147, 197, 253, 0.35) 0%, transparent 70%);
}

.ms-page::after {
  width: 180px;
  height: 180px;
  bottom: 18%;
  left: -50px;
  background: radial-gradient(circle, rgba(191, 219, 254, 0.4) 0%, transparent 70%);
  animation-delay: -5s;
  animation-duration: 18s;
}

.ms-page > * {
  position: relative;
  z-index: 1;
}

.ms-page--plain {
  background-color: #f5f8fc;
  background-image: none;
}

/* Entrance animations */
.ms-animate-header {
  animation: ms-header-in 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ms-animate-back {
  animation: ms-fade-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both;
}

.ms-animate-logo {
  animation: ms-logo-in 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
}

.ms-animate-powered {
  animation: ms-fade-up 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.28s both;
}

.ms-animate-nav {
  animation: ms-fade-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.35s both;
}

.ms-animate-heading {
  animation: ms-fade-up 0.45s cubic-bezier(0.22, 1, 0.36, 1) 0.42s both;
}

.ms-animate-card {
  animation: ms-card-in 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(0.48s + var(--card-index, 0) * 0.07s);
}

/* Header card */
.ms-header {
  position: relative;
  margin: 0 -16px 0;
  padding: 18px 16px 20px;
  text-align: center;
  background: #fff;
  border-radius: 0 0 22px 22px;
  box-shadow: 0 4px 18px rgba(30, 80, 160, 0.08);
  transition: box-shadow 0.35s ease;
}

.ms-header__back {
  position: absolute;
  left: 14px;
  top: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid #dbeafe;
  border-radius: 50%;
  background: #f8fbff;
  color: #2b6cb8;
  cursor: pointer;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1),
              box-shadow 0.25s ease,
              background 0.2s ease;
}

.ms-header__back:hover {
  transform: scale(1.08) translateX(-2px);
  background: #eef5ff;
  box-shadow: 0 4px 14px rgba(59, 130, 219, 0.22);
}

.ms-header__back:active {
  transform: scale(0.94);
}

.ms-header__logo-panel {
  display: inline-block;
}

.ms-header__logo {
  display: block;
  width: 168px;
  height: auto;
  max-height: 44px;
  margin: 0 auto;
  object-fit: contain;
}

.ms-header__powered {
  margin: 10px 0 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #6b8fbe;
}

.ms-header__powered a {
  text-decoration: none;
  transition: transform 0.2s ease;
}

.ms-header__powered a:hover {
  transform: scale(1.04);
}

.ms-header__powered a:hover .ms-fw--fore,
.ms-header__powered a:hover .ms-fw--warn {
  animation: ms-powered-shimmer 0.8s ease-in-out;
}

.ms-fw {
  font-style: normal;
  letter-spacing: 0.08em;
}

.ms-fw--fore {
  color: #4785ee;
}

.ms-fw--warn {
  color: #e31717;
}

/* Status pill */
.ms-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 18px auto 6px;
  padding: 7px 14px;
  width: fit-content;
  max-width: 100%;
  font-size: 12px;
  font-weight: 500;
  color: #5a6f86;
  background: #f4f7fb;
  border: 1px solid #dde6f0;
  border-radius: 999px;
  box-shadow: 0 2px 6px rgba(30, 60, 100, 0.06);
}

.ms-root .ms-status-pill {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

.ms-status-pill__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.2);
}

/* Analytics section */
.ms-analytics {
  overflow: auto;
  max-height: calc(95vh - 180px);
}

.ms-analytics--expanded {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 62vh;
}

.ms-analytics__heading {
  margin: 14px 4px 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #7a9bc4;
}

.ms-analytics__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ms-analytics--expanded .ms-analytics__list {
  gap: 14px;
}

/* Nav cards */
.ms-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  text-align: left;
  border: none;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(40, 90, 160, 0.1);
  cursor: pointer;
  overflow: hidden;
  transition:
      transform 0.3s cubic-bezier(0.34, 1.2, 0.64, 1),
      box-shadow 0.3s ease,
      background 0.35s ease;
}

.ms-card::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: radial-gradient(circle at var(--ripple-x, 50%) var(--ripple-y, 50%), rgba(59, 130, 219, 0.18) 0%, transparent 65%);
  opacity: 0;
  transform: scale(0);
  pointer-events: none;
}

.ms-card--pressed::after {
  animation: ms-ripple 0.45s ease-out forwards;
}

.ms-card:hover:not(:disabled) {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 10px 24px rgba(40, 90, 160, 0.16);
}

.ms-card:active:not(:disabled) {
  transform: translateY(-1px) scale(0.98);
  transition-duration: 0.1s;
}

.ms-card--accent::before {
  content: '';
  position: absolute;
  left: 0;
  top: 12px;
  bottom: 12px;
  width: 4px;
  border-radius: 0 4px 4px 0;
  background: #e31717;
  animation: ms-accent-pulse 2.5s ease-in-out infinite;
}

.ms-card--active {
  background: #3b82db;
  animation: ms-active-glow 2.2s ease-in-out infinite;
}

.ms-card--active:hover:not(:disabled) {
  transform: translateY(-3px) scale(1.02);
}

.ms-card--active .ms-card__title,
.ms-card--active .ms-card__subtitle,
.ms-card--active .ms-card__chevron {
  color: #fff;
}

.ms-card--active .ms-card__icon {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.ms-card--disabled {
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: 0 2px 8px rgba(40, 90, 160, 0.06);
}

.ms-card__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #e8f1fc;
  color: #3b7dd8;
  font-size: 1.05rem;
  transition: transform 0.35s cubic-bezier(0.34, 1.4, 0.64, 1),
              background 0.3s ease;
}

.ms-card:hover:not(:disabled) .ms-card__icon i {
  animation: ms-icon-pop 0.45s cubic-bezier(0.34, 1.4, 0.64, 1);
}

.ms-card--active .ms-card__icon {
  transition: background 0.3s ease;
}

.ms-card__icon--danger {
  color: #e31717;
}

.ms-card__body {
  flex: 1;
  min-width: 0;
}

.ms-card__title {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #2b6cb8;
  line-height: 1.25;
  transition: color 0.3s ease, transform 0.3s ease;
}

.ms-card:hover:not(:disabled) .ms-card__title {
  transform: translateX(2px);
}

.ms-card__subtitle {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: #7b8fa3;
  line-height: 1.35;
  transition: color 0.3s ease, opacity 0.3s ease;
}

.ms-card:hover:not(:disabled) .ms-card__subtitle {
  opacity: 0.9;
}

.ms-card__chevron {
  flex-shrink: 0;
  font-size: 12px;
  color: #b8c5d4;
  transition: transform 0.3s cubic-bezier(0.34, 1.2, 0.64, 1), color 0.3s ease;
}

.ms-card:hover:not(:disabled) .ms-card__chevron {
  animation: ms-chevron-nudge 0.6s ease-in-out;
  color: #3b7dd8;
}

.ms-card--active .ms-card__chevron {
  animation: ms-chevron-nudge 1.2s ease-in-out infinite;
}

/* Dashboard panel transition */
.ms-dashboard-enter-active,
.ms-dashboard-leave-active {
  transition: opacity 0.4s ease, transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.ms-dashboard-enter,
.ms-dashboard-leave-to {
  opacity: 0;
  transform: translateY(16px);
}

.ms-dashboard-panel {
  animation: ms-fade-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .ms-page::before,
  .ms-page::after,
  .ms-animate-header,
  .ms-animate-back,
  .ms-animate-logo,
  .ms-animate-powered,
  .ms-animate-nav,
  .ms-animate-heading,
  .ms-animate-card,
  .ms-card--accent::before,
  .ms-card--active,
  .ms-card--active .ms-card__chevron {
    animation: none !important;
  }

  .ms-card,
  .ms-header__back,
  .ms-card__icon,
  .ms-card__chevron,
  .ms-card__title {
    transition: none;
  }
}

/* Mobile reports list */
.ms-reports {
  margin-top: 12px;
}

.ms-reports__intro {
  margin-bottom: 4px;
}

.ms-reports__hint {
  margin: -4px 4px 14px;
  font-size: 13px;
  color: #7b8fa3;
  line-height: 1.35;
}

.ms-reports__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 220px;
  padding: 28px 18px;
  border-radius: 18px;
  background: linear-gradient(180deg, #f7faff 0%, #eef4fb 100%);
  border: 1px dashed #c9d8ea;
  text-align: center;
}

.ms-reports__empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 4px;
  border-radius: 16px;
  background: #e8f1fc;
  color: #3b7dd8;
  font-size: 1.25rem;
}

.ms-reports__empty-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #2b6cb8;
}

.ms-reports__empty-text {
  margin: 0;
  font-size: 12px;
  color: #7b8fa3;
}

</style>
<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->